import { employees, page as pageQuery, partners } from '@data/queries';
import { styled } from '@mui/material/styles';
import sanity from '@utils/sanity';
import { ReactElement } from 'react';
import { EmployeeProps } from 'src/@types/employee';
import { PageProps } from 'src/@types/page';
import { PartnerProps } from 'src/@types/partner';
import Routes from 'src/routes';
import { About, AboutOurVision, AboutStory } from 'src/sections/about';
import Newsletter from 'src/sections/newsletter/Newsletter';
import Partners from 'src/sections/partners/Partners';
import Team from 'src/sections/team/Team';
import { Page } from '../../src/components';
import { HEADER_DESKTOP_HEIGHT, HEADER_MOBILE_HEIGHT } from '../../src/config';
import Layout from '../../src/layouts';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: HEADER_MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    paddingTop: HEADER_DESKTOP_HEIGHT,
  },
}));

// ----------------------------------------------------------------------

type Props = {
  data: {
    employees: EmployeeProps[];
    partners: PartnerProps[];
  }
  page: PageProps;
};

export default function AboutUsPage({ data, page }: Props) {
  return (
    <Page seo={page.seo}>
      <RootStyle>
        <About />

        <AboutOurVision />

        <AboutStory />

        <Team members={data.employees} />

        <Partners partners={data.partners} />

        <Newsletter />
      </RootStyle>
    </Page>
  );
}

// ----------------------------------------------------------------------

AboutUsPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

// ----------------------------------------------------------------------

export const getStaticProps = async () => {
  const query = `
    {
      "employees": ${employees},
      "partners": ${partners}
    }
  `

  const data = await sanity.fetch(query);
  const page = await sanity.fetch(pageQuery, { slug: Routes.about });
  return {
    props: { data, page },
  };
};
